export default __webpack_public_path__ + "f4cfc6708cf6bfc17d4b1e775f594ae2.png";